<template>
  <v-settings-sidebar v-model="show" :temporary="temporarySidebar">
    <!-- A selector to set the active classification -->
    <v-classification-selector />
    <!-- A selector to set the active feature -->
    <v-feature-selector />
    <!-- A selector to filter the values by brand -->
    <v-brand-selector />
  </v-settings-sidebar>
</template>

<script>
import { mapState } from "vuex";
import VBrandSelector from "./BrandSelector";
import VClassificationSelector from "./ClassificationSelector";
import VFeatureSelector from "./FeatureSelector";
import VSettingsSidebar from "@/components/sidebars/SettingsSidebar.vue";

export default {
  components: {
    VBrandSelector,
    VClassificationSelector,
    VFeatureSelector,
    VSettingsSidebar
  },
  computed: {
    ...mapState("valueMapping", ["temporarySidebar"]),
    show: {
      get() {
        return this.$store.state.valueMapping.showingSidebar;
      },
      set(value) {
        if (value !== this.show) {
          this.$store.commit("valueMapping/toggleSidebar");
        }
      }
    }
  }
};
</script>
